import useMutation from "src/hooks/useMutation";

function useProductUpdate(id) {
  return useMutation({
    path: `/api/v1/products/${id}`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/products`,
      shouldRevalidate: true,
    },
  });
}

export default useProductUpdate;
